/**
 * Mock Bands, Sets, and Classes
 */

import type { CpBand, CpClass, CpSet } from '../../../types/curriculum_planning';

const now = Date.now();

export const mockCpBands: CpBand[] = [
  // Year 7 Bands
  {
    id: 'band-y7-upper',
    name: 'Upper Band',
    code: 'Y7U',
    yearGroupId: 'yg-7',
    academicYearId: 'ay-2024-2025',
    displayOrder: 1,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'band-y7-lower',
    name: 'Lower Band',
    code: 'Y7L',
    yearGroupId: 'yg-7',
    academicYearId: 'ay-2024-2025',
    displayOrder: 2,
    createdAt: now,
    updatedAt: now,
  },
  // Year 8 Bands
  {
    id: 'band-y8-upper',
    name: 'Upper Band',
    code: 'Y8U',
    yearGroupId: 'yg-8',
    academicYearId: 'ay-2024-2025',
    displayOrder: 1,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'band-y8-lower',
    name: 'Lower Band',
    code: 'Y8L',
    yearGroupId: 'yg-8',
    academicYearId: 'ay-2024-2025',
    displayOrder: 2,
    createdAt: now,
    updatedAt: now,
  },
  // Year 9 Bands
  {
    id: 'band-y9-upper',
    name: 'Upper Band',
    code: 'Y9U',
    yearGroupId: 'yg-9',
    academicYearId: 'ay-2024-2025',
    displayOrder: 1,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'band-y9-lower',
    name: 'Lower Band',
    code: 'Y9L',
    yearGroupId: 'yg-9',
    academicYearId: 'ay-2024-2025',
    displayOrder: 2,
    createdAt: now,
    updatedAt: now,
  },
];

export const mockCpSets: CpSet[] = [
  // Year 10 Maths Sets (no bands for KS4)
  {
    id: 'set-y10-maths-1',
    name: 'Y10 Maths Set 1',
    code: 'Y10M1',
    yearGroupId: 'yg-10',
    academicYearId: 'ay-2024-2025',
    pupilCount: 28,
    capacity: 30,
    displayOrder: 1,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'set-y10-maths-2',
    name: 'Y10 Maths Set 2',
    code: 'Y10M2',
    yearGroupId: 'yg-10',
    academicYearId: 'ay-2024-2025',
    pupilCount: 28,
    capacity: 30,
    displayOrder: 2,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'set-y10-maths-3',
    name: 'Y10 Maths Set 3',
    code: 'Y10M3',
    yearGroupId: 'yg-10',
    academicYearId: 'ay-2024-2025',
    pupilCount: 26,
    capacity: 30,
    displayOrder: 3,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'set-y10-maths-4',
    name: 'Y10 Maths Set 4',
    code: 'Y10M4',
    yearGroupId: 'yg-10',
    academicYearId: 'ay-2024-2025',
    pupilCount: 24,
    capacity: 30,
    displayOrder: 4,
    createdAt: now,
    updatedAt: now,
  },
  // Year 11 Maths Sets
  {
    id: 'set-y11-maths-1',
    name: 'Y11 Maths Set 1',
    code: 'Y11M1',
    yearGroupId: 'yg-11',
    academicYearId: 'ay-2024-2025',
    pupilCount: 30,
    capacity: 30,
    displayOrder: 1,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'set-y11-maths-2',
    name: 'Y11 Maths Set 2',
    code: 'Y11M2',
    yearGroupId: 'yg-11',
    academicYearId: 'ay-2024-2025',
    pupilCount: 28,
    capacity: 30,
    displayOrder: 2,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'set-y11-maths-3',
    name: 'Y11 Maths Set 3',
    code: 'Y11M3',
    yearGroupId: 'yg-11',
    academicYearId: 'ay-2024-2025',
    pupilCount: 26,
    capacity: 30,
    displayOrder: 3,
    createdAt: now,
    updatedAt: now,
  },
];

export const mockCpClasses: CpClass[] = [
  // Year 7 Classes (in bands)
  {
    id: 'class-7a',
    name: '7A',
    yearGroupId: 'yg-7',
    academicYearId: 'ay-2024-2025',
    bandId: 'band-y7-upper',
    pupilCount: 28,
    capacity: 30,
    formTutorId: 'teacher-001',
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'class-7b',
    name: '7B',
    yearGroupId: 'yg-7',
    academicYearId: 'ay-2024-2025',
    bandId: 'band-y7-upper',
    pupilCount: 29,
    capacity: 30,
    formTutorId: 'teacher-002',
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'class-7c',
    name: '7C',
    yearGroupId: 'yg-7',
    academicYearId: 'ay-2024-2025',
    bandId: 'band-y7-lower',
    pupilCount: 27,
    capacity: 30,
    formTutorId: 'teacher-003',
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'class-7d',
    name: '7D',
    yearGroupId: 'yg-7',
    academicYearId: 'ay-2024-2025',
    bandId: 'band-y7-lower',
    pupilCount: 28,
    capacity: 30,
    formTutorId: 'teacher-004',
    createdAt: now,
    updatedAt: now,
  },
  // Year 8 Classes
  {
    id: 'class-8a',
    name: '8A',
    yearGroupId: 'yg-8',
    academicYearId: 'ay-2024-2025',
    bandId: 'band-y8-upper',
    pupilCount: 30,
    capacity: 30,
    formTutorId: 'teacher-005',
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'class-8b',
    name: '8B',
    yearGroupId: 'yg-8',
    academicYearId: 'ay-2024-2025',
    bandId: 'band-y8-upper',
    pupilCount: 29,
    capacity: 30,
    formTutorId: 'teacher-006',
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'class-8c',
    name: '8C',
    yearGroupId: 'yg-8',
    academicYearId: 'ay-2024-2025',
    bandId: 'band-y8-lower',
    pupilCount: 28,
    capacity: 30,
    formTutorId: 'teacher-007',
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'class-8d',
    name: '8D',
    yearGroupId: 'yg-8',
    academicYearId: 'ay-2024-2025',
    bandId: 'band-y8-lower',
    pupilCount: 27,
    capacity: 30,
    formTutorId: 'teacher-008',
    createdAt: now,
    updatedAt: now,
  },
  // Year 9 Classes
  {
    id: 'class-9a',
    name: '9A',
    yearGroupId: 'yg-9',
    academicYearId: 'ay-2024-2025',
    bandId: 'band-y9-upper',
    pupilCount: 30,
    capacity: 30,
    formTutorId: 'teacher-009',
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'class-9b',
    name: '9B',
    yearGroupId: 'yg-9',
    academicYearId: 'ay-2024-2025',
    bandId: 'band-y9-upper',
    pupilCount: 29,
    capacity: 30,
    formTutorId: 'teacher-010',
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'class-9c',
    name: '9C',
    yearGroupId: 'yg-9',
    academicYearId: 'ay-2024-2025',
    bandId: 'band-y9-lower',
    pupilCount: 28,
    capacity: 30,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'class-9d',
    name: '9D',
    yearGroupId: 'yg-9',
    academicYearId: 'ay-2024-2025',
    bandId: 'band-y9-lower',
    pupilCount: 28,
    capacity: 30,
    createdAt: now,
    updatedAt: now,
  },
  // Year 10 Classes (no bands for KS4, uses sets instead)
  {
    id: 'class-10a',
    name: '10A',
    yearGroupId: 'yg-10',
    academicYearId: 'ay-2024-2025',
    pupilCount: 26,
    capacity: 30,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'class-10b',
    name: '10B',
    yearGroupId: 'yg-10',
    academicYearId: 'ay-2024-2025',
    pupilCount: 27,
    capacity: 30,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'class-10c',
    name: '10C',
    yearGroupId: 'yg-10',
    academicYearId: 'ay-2024-2025',
    pupilCount: 26,
    capacity: 30,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'class-10d',
    name: '10D',
    yearGroupId: 'yg-10',
    academicYearId: 'ay-2024-2025',
    pupilCount: 27,
    capacity: 30,
    createdAt: now,
    updatedAt: now,
  },
  // Year 11 Classes
  {
    id: 'class-11a',
    name: '11A',
    yearGroupId: 'yg-11',
    academicYearId: 'ay-2024-2025',
    pupilCount: 28,
    capacity: 30,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'class-11b',
    name: '11B',
    yearGroupId: 'yg-11',
    academicYearId: 'ay-2024-2025',
    pupilCount: 28,
    capacity: 30,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'class-11c',
    name: '11C',
    yearGroupId: 'yg-11',
    academicYearId: 'ay-2024-2025',
    pupilCount: 27,
    capacity: 30,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'class-11d',
    name: '11D',
    yearGroupId: 'yg-11',
    academicYearId: 'ay-2024-2025',
    pupilCount: 28,
    capacity: 30,
    createdAt: now,
    updatedAt: now,
  },
];
